<app-company-reservation-flow-v2
  #reservationFlow
  [editingReservationId]="editingReservationId"
  [editingReservationCode]="editingReservationCode"
></app-company-reservation-flow-v2>
